import type {} from "@lit/react";
import { AccordionHeading as AccordionHeadingElement, } from "@vaadin/accordion/vaadin-accordion-heading.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { AccordionHeadingElement, };
export type AccordionHeadingEventMap = Readonly<{}>;
const events = {} as AccordionHeadingEventMap;
export type AccordionHeadingProps = WebComponentProps<AccordionHeadingElement, AccordionHeadingEventMap>;
export const AccordionHeading = createComponent({
    elementClass: AccordionHeadingElement, events, react: React, tagName: "vaadin-accordion-heading"
});
